<template>
<div class="grid"  @click="edit">
<div :class="labelclass">
<p class="click_edit_value_title">{{title}}:</p>
</div>
<template v-if="editing">
<div :class="inputareaclass" class="mt-3">
<div class="grid"  v-click-away="cancel">
<div class="col">
<InputSwitch v-model="inputdata" @change="submitChanges"  />

</div>
<div class="col-fixed " style="width:110px">

</div>
</div>
</div>
</template>

<template v-if="!editing">  
<div :class="inputareaclass">
<div class="click_edit_value mt-2 pb-0 pt-1 mb-0" v-html="$filters.booleanView(value)"></div>
</div>
</template>
</div>	
</template>

<script>
export default {

  name: 'ClickEditSwitch',
  props:["title","value","valkey","read_only","label_width","hide_label"],
  data () {
    return {
    	editing:false,
    	inputdata:false,
    }
  },
  computed:{
    labelclass()
    {
      if(this.label_width=="wide")
      {
        return "col-3 md:col-3"
      }
      else
      {
        return "col-3 md:col-2"
      }      
    },
    inputareaclass()
    {
      if(this.hide_label)
      {
        return "col-9 md:col-12 mt-0"
      }
      else
      {
        if(this.label_width=="wide")
        {
          return "col-9 md:col-9 mt-0"
        }
        else
        {
          return "col-9 md:col-10 mt-0"
        }        
      }
    },
    valuewatch()
    {
      return this.value
    },
    readonly()
    {
      
      if(this.read_only)
      {
        return true
      }
      return false
    },
  },
  watch:{
  	valuewatch(nevVal,oldVal)
  	{
      console.log("val ch")
      console.log(this.value)
      if(this.value===1)
      {
        this.inputdata=true
      }
      else{
        this.inputdata = false
      }

  		 this.editing = false
  	}
  },
  methods:{
  	submitChanges()
  	{
  		this.$emit("dataChanged",{value:this.inputdata,key:this.valkey})
  		
  	},
  	async edit()
  	{
      if(this.readonly)
      {
        return false
      }
      if(!this.editing)
        {
          if(this.value===1)
        {
          this.inputdata = await true
        }
        else{
          this.inputdata = await false
        }

      }
      
  		
  		this.editing = await true
  		await setTimeout(()=>{
  			if(this.$refs.inputarea)
  			{
  				this.$refs.inputarea.$el.focus()
  			}
  			
  		},10)
  		
  	},
  	cancel()
  	{
  		setTimeout(()=>{
  			this.editing = false
  		},10)
  		
  	},

  }
};
</script>

<style lang="css" scoped>
</style>